<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ Object.entries(this.data).length === 0 ? "NOUVEAU" : "MODIFIER UN" }} PAIEMENT</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false, initVal(), error_data =  []" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2">
                <vs-input autocomplete="off" class="mt-5 w-full" label="Nom"
                          :danger="error_data.last_name ? true : false"
                          :danger-text="error_data.last_name ? error_data.last_name[0] : ''"
                          v-model="last_name" placeholder="Nom" />

                <vs-input class="mt-5 w-full"
                          autocomplete="off"
                          label="Prénoms" v-model="first_name"
                          :danger="error_data.first_name ? true : false"
                          :danger-text="error_data.first_name ? error_data.first_name[0] : ''"
                          placeholder="Prénoms" />

                <vs-select class="mt-5 w-full"
                           :danger="error_data.type_speciality_id ? true : false"
                           :danger-text="error_data.type_speciality_id ? error_data.type_speciality_id[0] : ''"
                           @change="changeSpecialities"
                           v-model="type_speciality_id" label="Type de spécialité" autocomplete="">
                    <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in types" />
                </vs-select>
                <vs-select class="mt-5 w-full"
                          @change="changeRest"
                           :danger="error_data.speciality_id ? true : false"
                           :danger-text="error_data.speciality_id ? error_data.speciality_id[0] : ''"
                           v-model="speciality_id" label="Spécialité" autocomplete="">
                    <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in specialities" />
                </vs-select>
                <vs-select class="mt-5 w-full"
                           :danger="error_data.praticien_id ? true : false"
                           :danger-text="error_data.praticien_id ? error_data.praticien_id[0] : ''"
                           v-model="praticien_id" label="Praticien" autocomplete="">
                    <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in practiciensData" />
                </vs-select>
                <vs-select class="mt-5 w-full"
                           :danger="error_data.user_id ? true : false"
                           :danger-text="error_data.user_id ? error_data.user_id[0] : ''"
                           v-model="user_id" label="Agent" autocomplete="">
                    <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in agents" />
                </vs-select>
            </div>
        </VuePerfectScrollbar>
        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button @click="saveOrUpdate()" class="mr-6">Soumettre</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false, initVal(), error_data =  []">Annuler</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    export default {
        components: {VuePerfectScrollbar},
        props: {
            isSidebarActive: {
              type: Boolean,
              required: true
            },
            data: {
              type: Object,
              default: () => {},
            },
            agents: {
              type: Array,
              default: () => [],
            },
            editEl: {
              type: Boolean
            },
            callBackAdd: {
              type: Function
            },
            specialitiesPop: []
        },
        data() {
            return {
              dataId: '',
              speciality_id: '',
              first_name: '',
              last_name: '',
              type_speciality_id: '',
              praticien_id: null,
              user_id: '',
              settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
              },
              error_data: [],
              types: [
                {id: '1', name: 'Consultation en chirurgie externe'},
                {id: '2', name: 'Consultation en medecine externe'},
                {id: '3', name: 'Autres types de consultation'},
              ],
              specialities: [],
              practiciensData: [],
              isMounted: false,
              isMountedF: false,
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                        this.$emit('closeSidebar')
                    }
                }
            },
        },
        methods: {
            initValues() {
                if(this.data.id) return;
                this.dataId = '';
            },
            getPraticien() {
              const item = this.specialities.find(el => el.id === this.speciality_id)
              if (item && item.praticien != null){
                if (!this.isMountedF){
                  this.praticien_id = null
                  this.practiciensData.unshift({id: null, name: 'Sélectionner'})
                }else{
                  this.isMountedF = false
                }
                this.$http
                .post("/praticiens/where", {
                  id: item.praticien
                })
                .then((response) => {
                  this.practiciensData = response.data;
                  this.practiciensData.unshift({
                    id: null,
                    name: 'Sélectionner'
                  })
                })
                .catch((error) => {
                  if (error.response.status === 401) {
                  this.$vs.notify({
                    title: 'Erreur',
                    text: 'Votre session a expiré',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    position: 'top-right'
                  })
                  this.$router.push({name: "page-login"})
                }
                });
              }else{
                this.praticien_id = null
                this.practiciensData = [{id: null, name: 'Sélectionner'}]
              }
            },
            changeSpecialities(){
              if (this.type_speciality_id != '' || this.type_speciality_id != null){
                if (this.isMounted){
                  this.specialities = this.specialitiesPop.filter(el => el.type == this.type_speciality_id)
                  this.specialities.unshift({id: '', name: 'Sélectionner', praticien: null})
                  this.isMounted = false
                }else{
                  this.speciality_id = ''
                  this.specialities = this.specialitiesPop.filter(el => el.type == this.type_speciality_id)
                  this.specialities.unshift({id: '', name: 'Sélectionner', praticien: null})
                  this.praticien_id = null
                  this.practiciensData = [{id: null, name: 'Sélectionner'}]
                }
              }
            },
            changeRest(){
              this.getPraticien()
            },
            initVal(){
              this.dataId = ''
              this.first_name = '';
              this.last_name = '';
              this.type_speciality_id = '';
              this.speciality_id = '';
              this.user_id = '';
              this.praticien_id = null;
            },
            saveOrUpdate(){
              const item = this.practiciensData.find(el => el.id === this.praticien_id)
              this.$vs.loading()
              this.$http.post('/payment/edit', {
                first_name: this.first_name,
                last_name: this.last_name,
                type_speciality_id: this.type_speciality_id,
                speciality_id: this.speciality_id,
                id: this.dataId,
                user_id: this.user_id,
                praticien_id: this.praticien_id,
                praticien: item.name ? item.name : ''

              }).then(res => {
                this.error_data = []
                this.$vs.loading.close()
                this.initVal()
                  this.$emit('updateData', res.data.content)
                  this.$emit('closeSidebar')
                  this.$vs.notify({
                    time: 5000,
                    title: 'Succès!',
                    text: "Opération effectuée avec succès",
                    color: 'success',
                    iconPack: 'feather',
                    position: 'top-right',
                    icon: 'icon-check-circle'
                  })
              }).catch(error => {
                if (error.response.status === 422){
                  this.$vs.loading.close()
                  this.error_data = error.response.data.errors
                }
              })
            },
        },
        watch: {
          isSidebarActive(val) {
            if(!val) return;
            if(Object.entries(this.data).length === 0) {
                this.initValues()
            } else {
              let { id, last_name, first_name, type, speciality_id, user_id, praticien_id } = JSON.parse(JSON.stringify(this.data));
              this.dataId = id
              this.first_name = first_name
              this.last_name = last_name
              this.type_speciality_id = type
              this.speciality_id = speciality_id
              this.user_id = user_id
              this.praticien_id = praticien_id
              this.isMounted = true
              this.isMountedF = true
            }
          },
        }

    }
</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
    }
    .vs-input-number {
        justify-content: space-around;
    }
</style>
